
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Internship</h1>
                </div>
            </div>
        </div>			
    </div>
</section>
<section class="section-lg chair-msg">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="inner-title"  >
                    <h3>Internship</h3>							
                   
                </div>
                <div class="text-justify" >
                    <p>Our economy is changing daily, and with it, the talents, skills, and experience needed to be a part of that growth cycle are too. The job market is a competitive one, and often that is a tough learning curve for recent graduates. This is a big reason behind the growth of applied learning and internship opportunities becoming a key part of the college experience for all students.Internships are a great way to apply the knowledge from the classroom to real-world experience. Learning is one thing, but taking those skills into the workforce and applying them is a great way to explore different career paths and specializations that suit individual interests.</p>
                    <p>Internship benefits the students in the working environment, and it also builds their professional network. Internships provide a great environment to meet professionals from the fields in which the student want to pursue career.</p>
                    <p>Internships also help students to learn all about workplace culture, employee relations, and leadership structure, which should help them onboard in their first professional job with more ease than if they haven’t had any professional experience.Thus the most important element of internships is that they integrate classroom knowledge and theory with practical application and skills developed in professional or community settings. They also bring a wealth of benefits to students, both while completing a degree and when seeking a career path post-graduation.</p>
                </div> 
            </div>
        </div>
        <div class="row mb-20">
            <div class="col-md-3 col-6">
              <div class="gallery-item" data-aos="zoom-in-down">
                <a href="assets/images/gallery/place_inter-1.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/place_inter-1.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                </a>
              </div>
            </div>
            <div class="col-md-3 col-6">
              <div class="gallery-item" data-aos="zoom-in-down">
                <a href="assets/images/gallery/place_inter-2.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/place_inter-2.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                </a>
              </div>
            </div>
            <div class="col-md-3 col-6">
              <div class="gallery-item" data-aos="zoom-in-down">
                <a href="assets/images/gallery/place_inter-3.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/place_inter-3.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                </a>
              </div>
            </div>
            <div class="col-md-3 col-6">
              <div class="gallery-item" data-aos="zoom-in-down">
                <a href="assets/images/gallery/place_inter-4.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/place_inter-4.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                </a>
              </div>
            </div>
            <div class="col-md-3 col-6">
              <div class="gallery-item" data-aos="zoom-in-down">
                <a href="assets/images/gallery/place_inter-5.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/place_inter-5.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                </a>
              </div>
            </div>
            <div class="col-md-3 col-6">
              <div class="gallery-item" data-aos="zoom-in-down">
                <a href="assets/images/gallery/place_inter-6.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/place_inter-6.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                </a>
              </div>
            </div>
            <div class="col-md-3 col-6">
              <div class="gallery-item" data-aos="zoom-in-down">
                <a href="assets/images/gallery/place_inter-7.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/place_inter-7.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                </a>
              </div>
            </div>
        </div>
    </div>
</section>

